import React, {Component} from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import T from '../../../SPRINTA/translate/T'
import style from './style.css'

import { Col, Row } from '../../atoms/Grid'
import Avatar from '../../atoms/Avatar'
import Button from '../../../SPRINTA/atoms/Button'
import PlaceHolder from '../../atoms/PlaceHolder'
import Loading from '../../atoms/Loading'
import FontIcon from '../../atoms/FontIcon'
import Modal from '../../atoms/Modal'
import Font from '../../atoms/Font'

import PostQuestionForum from '../../molecules/PostQuestionForum'
import ResponseForum from '../../molecules/ResponseForum'
import CommentForum from '../../molecules/CommentForum'


import { openModal } from '../../../modules/actions/Modais'
import * as discussion from '../../../utils/discussion'

import { date, dateHour } from '../../../libraries/Formatter'

class Discussion extends Component {


    state = {
        show: {},
        questions: {
            status: 'loading',
            data: [],
            total: 0,
            loaded: 0,
            toDelete: null,
            modalConfirmAnswer: null,
            deletingQuestion: false,
            deletingAnswer: false
        },
        answers: {},
        answerStatus: {}
    }

    toggleShow(id) {
        var state = (this.state.show[id]) ? false : true
        this.setState({
            ...this.state,
            show: {
                ...this.state.show,
                [id]: state
            }
        })
    }
    loadMore() {
        this.setState({
            ...this.state,
            questions: {
                ...this.state.questions,
                status: 'loading'
            }
        })
        let type = this.props.data.type || 'event'
        discussion.getQuestions(this.props.data.token, type, this.state.questions.loaded, 6).
        then(resp => {
            console.log(resp)
            this.setState(state => ({
                ...state,
                questions: {
                    ...state.questions,
                    total: resp.total,
                    loaded: state.questions.loaded + resp.result.length,
                    data: [
                        ...state.questions.data,
                        ...resp.result,
                    ],
                    status: 'done'
                }
            }))
        })
    }

    loadAnswers(id) {
        this.setState(state => ({
            ...state,
            answers: {
                ...state.answers,
                [id]: {
                    status: 'loading'
                }
            }
        }))
        discussion.getAnswers(id).then(resp => {
            this.setState(state => ({
                ...state,
                answers: {
                    ...state.answers,
                    [id]: {
                        status: 'done',
                        data: resp.result
                    }
                }
            }))
        })
    }

    componentWillMount() {
        this.loadMore()
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.login && nextProps.login.isLogged !== this.props.login.isLogged) {
            this.setState({
                questions: {
                    ...this.state.questions,
                    loaded: 0,
                    data: [],
                }
            }, () => {
                this.loadMore()
            })
        }
    }

    addAnswer(data) {
        data.is_admin = "1"

        data.user_id = this.props.login.id_user
        data.user_name =  this.props.login.user.name
        data.user_avatar =  this.props.login.user.avatar
        data.user_uri =  this.props.login.user.url_token

        // var questions = this.state.questions.data

        // questions.filter( function( elem, index, array ) {
        //     if(elem.id === data.question)
        //     elem = {
        //         ...elem,
        //         answers: elem.answers++
        //     }

        //     return { index, elem }
        // })


        this.setState(state => ({
            ...state,
            answers: {
                ...state.answers,
                [data.question]: {
                    status: 'partial',
                    data: [
                        ...this.state.answers[data.question] ? this.state.answers[data.question].data : {},
                        data
                    ]
                }
            }
        }))
    }

    addQuestion(data) {
        data.is_admin = "1"
        data.type = data.privacity
        data.user_id = this.props.login.id_user
        data.user_name = this.props.login.user.name
        data.user_avatar = this.props.login.user.avatar
        data.user_uri = this.props.login.user.url_token
        data.event_id = this.props.data.id
        data.answers = 0

        this.state.questions.data.unshift(data)
        this.state.questions.loaded++
        this.state.questions.total++


        this.setState({
            ...this.state,
            answers: {
                ...this.state.answers,
                [data.id]: {
                    status: 'done',
                    data: []
                }
            }
        })
    }

    userLoggedQuestion(evt) {
        if(!this.props.login.isLogged) {
            evt.preventDefault()
            this.props.openModal('modal-login')
        }
    }

    btnComment(id) {
        if(!this.props.login.isLogged) {
            this.props.openModal('modal-login')
        } else {
            this.toggleShow(id)
        }
    }

    deleteQuestion(id) {
        this.setState({
            deletingQuestion: true
        })
        discussion.deleteQuestion(id)
        .then(resp => {
            this.setState(state => ({
                ...state,
                deletingQuestion: false,
                questions: {
                    ...state.questions,
                    loaded: state.questions.loaded-1,
                    data: state.questions.data.filter(question => question.id !== id),
                    total: state.questions.total - 1
                }
            }))
            this.refs['modal-confirm'].hide()
        })
    }

    deleteAnswer(data) {
        var id = data.id
        var question = data.question
        this.setState({
            deletingAnswer: true
        })

        discussion.deleteAnswer(id)
        .then(resp => {
            this.setState(state => ({
                ...state,
                deletingAnswer: false,
                answers: {
                    ...state.answers,
                    [question]: {
                        ...state.answers[question],
                        data: state.answers[question].data.filter(answer => answer.id !== id)
                    }
                }
            }))
            this.refs['modal-confirm-answer'].hide()
        })
    }

    confirmDeleteQuestion(id) {
        this.setState({
            toDelete: id
        }, () => {
            this.refs['modal-confirm'].show()
        })
    }

    confirmDeleteAnswer(question, id) {
        this.setState({
            toDeleteAnswer: {
                question, id
            }
        }, () => {
            this.refs['modal-confirm-answer'].show()
        })
    }


    render() {
        return (
            <div>
                <div style={{marginBottom: '60px'}} onClick={(e) => this.userLoggedQuestion(e)}>
                    <PostQuestionForum private={this.props.private} disabled={!this.props.login.isLogged} handleAdd={(data) => {
                        this.addQuestion(data)
                    }} token={this.props.data.token} type={this.props.data.type || 'event'}/>
                </div>
                <br />
                {this.state.questions.status === 'loading' && this.state.questions.total === 0 && (
                    <div>
                        <PlaceHolder type='retangle' height='200px'/>
                        <PlaceHolder type='retangle' height='200px'/>
                    </div>
                )}
                {this.state.questions.data.map(question => (
                    <Row key={question.id} className={`${style.comentario}`}>
                        <Col size={12}>
                            <div className={`${style.avatarwrap}`}>
                                <Avatar size={35} img={`${question.user_avatar_path}`} />
                            </div>
                            <h4>{question.user_name}</h4>
                            {question.create_at && (
                                <span style={{fontSize: '10px'}}>{date(question.create_at.split(' ')[0]).br} - {dateHour(question.create_at.split(' ')[1])}</span>
                            )}
                            <div className={style.iconsHeader}>
                                {question.type === 'private' &&  (
                                    <span style={{display:'inline-block', marginRight: '40px', marginTop: '12px'}}>
                                        <FontIcon name='lock' size={16} color='#ccc'/>
                                    </span>
                                )}
                                {question.is_admin === "1" &&  (
                                    <span className={style.iconDelete} onClick={ () => this.confirmDeleteQuestion(question.id)}>
                                        <FontIcon name='trash' size={12}/>
                                    </span>
                                )}
                            </div>
                            <p>{question.content}</p>

                            <div className={`${style.morecomments}`}>
                                {!this.state.show[question.id] && (
                                    <Button style={{paddingTop: '5px', paddingBottom: '5px'}} inline theme="secondary" onClick={() => this.btnComment(question.id)}>{T.txt('comment')}</Button>
                                )}

                                { question.answers > 0 && (!this.state.answers[question.id] || this.state.answers[question.id].status === 'loading' || this.state.answers[question.id].status === 'partial') && (
                                    <Button style={{marginLeft: '20px', paddingTop: '5px', paddingBottom: '5px'}} theme='primary' onClick={() => this.loadAnswers(question.id)} inline>
                                        {(this.state.answers[question.id] && this.state.answers[question.id].status === 'loading') ? (
                                            <Loading
                                                color='#fff'
                                                size='12px' />
                                        ) : `${T.txt('answers')} (${question.answers})`}
                                    </Button>
                                )}
                            </div>

                            { this.state.answers[question.id] && (this.state.answers[question.id].status === 'done' || this.state.answers[question.id].status === 'partial') && (
                                <div>
                                    { this.state.answers[question.id].data.map(answer => (
                                        <CommentForum handleDelete={ (id) => this.confirmDeleteAnswer(question.id, id) } key={answer.id} data={answer} />
                                    ))}
                                </div>
                            )}


                            {this.props.login.isLogged && (
                                <ResponseForum
                                    show={this.state.show[question.id]}
                                    handleClose={() => {
                                        this.toggleShow(question.id)
                                    }}
                                    question={question.id}
                                    handleAdd={(data) => this.addAnswer(data)}
                                />
                            )}


                        </Col>
                    </Row>
                ))}


                { (this.state.questions.loaded < this.state.questions.total) && (
                    <div className={`${style.more}`}>
                        <Button theme='light' onClick={() => this.loadMore()}
                            disabled={(this.state.questions.status === 'loading') ? true : false}
                        >
                            {(this.state.questions.status === 'loading') ? (
                                <Loading
                                    color='#f50'
                                    size='30px' />
                            ) : T.txt('load_more')}
                        </Button>
                    </div>
                ) }


                <Modal
                    ref='modal-confirm'
                    width='400px'
                    padding='30px'
                >
                    <Col>
                        <div className={style.textModal}>
                            <p><Font size={30} color='#4a4a4a' weight='100'>{T.txt('confirmation')}</Font></p>
                            <p><Font color='#4a4a4a'>{T.txt('confirmation_delete_question')}</Font></p>
                        </div>
                    </Col>
                    <Col size={6}>
                        <Button theme='light' onClick={() => { this.refs['modal-confirm'].hide() }}>{T.text('back')}</Button>
                    </Col>
                    <Col size={6}>
                        <Button theme='primary' disabled={this.state.deletingQuestion} color='red' onClick={() => { this.deleteQuestion(this.state.toDelete) }}>
                            {this.state.deletingQuestion ? (
                                    <Loading
                                        color='#fff'
                                        size='30px' />
                                ) : T.text('confirm')}
                        </Button>
                    </Col>
                </Modal>

                <Modal
                    ref='modal-confirm-answer'
                    width='400px'
                    padding='30px'
                >
                    <Col>
                        <div className={style.textModal}>
                            <p><Font size={30} color='#4a4a4a' weight='100'>{T.text('confirmation')}</Font></p>
                            <p><Font color='#4a4a4a'>{T.text('confirmation_delete_answer')}</Font></p>
                        </div>
                    </Col>
                    <Col size={6}>
                        <Button theme='light' onClick={() => { this.refs['modal-confirm-answer'].hide() }}>{T.text('back')}</Button>
                    </Col>
                    <Col size={6}>
                        <Button
                            theme='primary'
                            disabled={this.state.deletingAnswer}
                            onClick={() => { this.deleteAnswer(this.state.toDeleteAnswer) }}>
                            {this.state.deletingAnswer ? (
                                <Loading
                                    color='#fff'
                                    size='30px' />
                            ) : T.text('confirm')}
                        </Button>
                    </Col>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    login: state.login
})
const mapDispatchToProps = dispatch => bindActionCreators({
    openModal
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Discussion)



// WEBPACK FOOTER //
// ./src/components/organisms/Discussion/index.js